import { ProjectFilesView } from '@/features/project-files/public';

interface TaskDocumentsViewProps {
  projectId: string;
}

export function TaskDocumentsView({ projectId }: TaskDocumentsViewProps) {
  return <ProjectFilesView projectId={projectId} />;
}
